module.exports = __webpack_public_path__ + "img/jpeg.b48fcca9.svg";